import React from "react";
import "./SubStone.css";

const SubStone = ({ imageSrc, heading, buttonText, onButtonClick }) => {
  return (
    <section className="substone-section">


  <div
    className="substone-image"
    style={{ backgroundImage: `url(${imageSrc})` }}
  ></div>
    <div className="substone-text">
    <h1>{heading}</h1>
    <button className="explore-btn" onClick={onButtonClick}>
      {buttonText}
    </button>
  </div>
</section>

  );
};

export default SubStone;
